import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

interface Path {
    filename?: string;
    dirname?: string;
}

interface Args {
    selector?: string;
    [key: string]: unknown;
}

interface ChunkModule {
    default: unknown;
}

interface ImportChunkOptions {
    selector: string;
    path?: Path;
    chunk: (path: Path) => Promise<ChunkModule>;
    args?: Args;
}

function importChunk({ selector, path = {}, chunk, args = {} }: ImportChunkOptions) {
    const elements = document.querySelectorAll(selector);
    args.selector = selector;
    if (elements.length > 0 && typeof chunk === 'function') {
        chunk(path)
            .then(module => {
                if (typeof module.default === 'function') {
                    (
                        module.default as (
                            elements: NodeListOf<Element>,
                            args: Args
                        ) => void
                    )(elements, args);
                } else {
                    console.warn('module does not contain a default function', module);
                }
            })
            .catch(error => {
                if (error instanceof Error && error.name === 'ChunkLoadError') {
                    LoggingHandler().logError(error.message, {
                        searchTerm: selector,
                        fileName: path.filename || '',
                    });
                } else {
                    const err = error instanceof Error ? error : new Error(String(error));
                    LoggingHandler().logError(err.message, {
                        searchTerm: selector,
                        fileName: path.filename || '',
                    });
                    throw error;
                }
            });
    }
}

export { importChunk };
